import React, { Fragment, useEffect, useState } from 'react';
import './mytests.scss';
import { Card } from 'react-bootstrap';
import Select, { components } from 'react-select';
import { useDispatch } from 'react-redux';
import { resetQuestions, resetLoadingQuestions } from '../../Redux/ActionCreators/testLibraryAction';

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <img src='/images/mdi_menu-down.svg' alt='' />
        </components.DropdownIndicator>
    );
};

const SelectQuestions = ({ testName, duration, isQuestionLoading, additionalQuestions, fetchData, total, goBackNewTest, backTomyTest, selectOneQuestion, selectedQuestion, removeQuestion,
    saveSelectQuestion, skills, topics, setSkill, setTags, handleSearch, saveTest, addToAssessment, openEdit, editDetails, editMyTest, isLoading, selectedLanguages, testType, setSuccessMessage, setsuccessMessageText, categoryId, customLoader, manualPage, manualPerPage, totalQuestions, onManualPaginate, refetchManualQuestions }) => {

    const [manuallTestSummary, setManuallTestSummary] = useState();
    const [query, setQuery] = useState('');
    const [area, setArea] = useState('');
    const [topic, setTopic] = useState('');
    const dispatch = useDispatch();
    const searchTimer = React.useRef(null);

    useEffect(() => {
        const firstRender = async () => {
            await setManuallTestSummary(editDetails ? true : false);
        }
        firstRender();
    }, [editDetails])

    // useEffect(() => {
    //     if (!manuallTestSummary) return;
    //     dispatch(resetQuestions());
    //     if (testType === 8) {
    //         fetchData(1);
    //     } else {
    //         fetchData(1);
    //     }
    // }, [ selectedCodingLanguage?.value, area?.value, topic?.value, testType]);



    const manuallsummary = () => {
        setManuallTestSummary(true);
        saveSelectQuestion(selectedQuestion);
    }

    const selectQuestion = (e, detail) => {
        selectOneQuestion(e.target.value, e.target.checked, detail)
    }

    const changeSearch = (val) => {
        if (testType === 8 && !selectedLanguages?.length) {
            setSuccessMessage(true);
            setsuccessMessageText('No languages selected. Please go back and select languages first.');
            return;
        }
        setQuery(val);
        clearTimeout(searchTimer.current);
        searchTimer.current = setTimeout(() => handleSearch(val), 600);
    }

    const selectSkill = async (e) => {
        await setArea(e);
        await setSkill(e);
        refetchManualQuestions({
            skillIdOverride: e?.value || 0,
            topicIdOverride: 0,
        });
    }

    const selectTopic = async (e) => {
        await setTopic(e);
        await setTags(e)
    }

    const getPageNumbers = () => {
        if (totalPages <= 4) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        } else if (manualPage <= 3) {
            return [1, 2, 3, "...", totalPages];
        } else if (manualPage >= totalPages - 2) {
            return [1, "...", totalPages - 2, totalPages - 1, totalPages];
        } else {
            return [
                1,
                "...",
                manualPage - 1,
                manualPage,
                manualPage + 1,
                "...",
                totalPages,
            ];
        }
    };

    const totalPages = Math.ceil(totalQuestions / manualPerPage);
    const startItem = totalQuestions > 0 ? (manualPage - 1) * manualPerPage + 1 : 0;
    const endItem = Math.min(manualPage * manualPerPage, totalQuestions);

    return (
        <Fragment>
            {isLoading ?
                <div className="loading-overlay" style={{ alignItems: "start", height: "auto" }}>
                    <div className="spinner-border" role="status" style={{ width: "1rem", height: "1rem" }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div> :
                manuallTestSummary ?
                    (
                        <div className='newtests'>
                            <div className='textclass d-flex align-items-center'>
                                <img className='backarrow manuallback' src='/images/back.svg' onClick={() => {
                                    goBackNewTest();
                                    editDetails && setManuallTestSummary(false)
                                }} alt='' />&nbsp;&nbsp;
                                <h1 className='newtestpage'>Test Summary</h1>
                            </div>
                            <div>
                                <Card className='summarycard' style={{marginBottom:'unset'}}>
                                    <div className='summaryheader d-flex justify-content-center align-items-center'>
                                        <div className='d-flex headeritem'>
                                            <img className='editimg' src='/images/info-green.svg' alt='' />&nbsp;&nbsp;
                                            <div className='' >
                                                <p>Test Name</p>
                                                <div className='d-flex justify-content-center align-items-center mt-1' >
                                                    <h4>{testName}</h4> &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <img className='cursor-pointer' src='/images/edit-icon.svg' alt='' onClick={openEdit} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='d-flex headeritem'>
                                            <img className='editimg' src='/images/ph_question-light.svg' alt='' />
                                            <div className='' >
                                                <p>Questions</p>
                                                <div className='text-center mt-1' >
                                                    <h4>{selectedQuestion?.length}</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='d-flex headeritem'>
                                            <img className='editimg' src='/images/lets-icons_time-progress-light.svg' alt='' />&nbsp;&nbsp;
                                            <div className='' >
                                                <p>Minutes</p>
                                                <div className='d-flex  justify-content-center align-items-center mt-1' >
                                                    <h4>{duration}</h4> &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <img className='cursor-pointer' src='/images/edit-icon.svg' onClick={openEdit} alt='' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card>

                                {(testType === 7 || testType === 8) && selectedLanguages?.length > 0 && (
                                    <div style={{ padding: "8px 16px", border: "1px solid #f0f0f0", display: "flex", alignItems: "center", flexWrap: "wrap", gap: 6, background:'#FFFFFF' }}>
                                        <small style={{ color: "#555c5e", fontWeight: 600, marginRight: 4 }}>Allowed Languages:</small>
                                        {selectedLanguages.map(l => (
                                            <span key={l.value} style={{
                                                display: "inline-block",
                                                background: "#f1f1f1",
                                                borderRadius: 12,
                                                padding: "2px 10px",
                                                fontSize: 12,
                                                color: "#333",
                                                fontWeight: 500,
                                            }}>
                                                {l.label}
                                            </span>
                                        ))}
                                    </div>
                                )}
                                <Card className='manuallquestionsbody'>
                                    <div className='manuallsummarybody'>
                                        <div className='d-flex justify-content-between align-items-center' style={{ gap: "20px" }}>
                                            <h3>Question list</h3>
                                            <h2 className='cursor-pointer'
                                                onClick={() => {
                                                    setSkill('');
                                                    setArea('');
                                                    setTopic('');
                                                    dispatch(resetQuestions());
                                                    dispatch(resetLoadingQuestions());
                                                    setManuallTestSummary(false);
                                                }}
                                            >ADD QUESTIONS</h2>
                                        </div>
                                        {

                                            selectedQuestion?.length > 0 ?

                                                <div className="question-list">
                                                    {selectedQuestion && selectedQuestion?.map(el => {
                                                        return (
                                                            <div className='question-selected'>
                                                                <ul key={el.id}>
                                                                    <li className=''>
                                                                        <h4 >{el.skillName}</h4>
                                                                        <p  >{el.skillTopicName}</p>
                                                                    </li>
                                                                    <li>
                                                                        <h5 className='elipsis-3' dangerouslySetInnerHTML={{ __html: el?.question || el.name }} />
                                                                    </li>
                                                                    <li>
                                                                        <img src='/images/delete-icon.svg' className='cursor-pointer' alt='' onClick={() => removeQuestion(el)} />
                                                                    </li>
                                                                    <hr />
                                                                </ul>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                :
                                                <div className='empty-question'>
                                                    <img src='/images/magnifier.svg' alt='' />
                                                    <div className='mt-2'>
                                                        <h3>There is no selected tests</h3>
                                                    </div>
                                                </div>

                                        }
                                    </div>

                                </Card>
                                <div className='testpagebtn' >
                                    <button className='submitbtn' onClick={editDetails ? editMyTest : saveTest} >SAVE & EXIT</button>
                                    <button className='assbtn' onClick={addToAssessment}>ADD TO ASSESSMENT</button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className='newtests'>
                            <Card className='headclass' >
                                <div className='manullhead' >
                                    <h3 className='manullheadmain'><img className='manuallback' src='/images/leftarrow-black-icon.svg' onClick={() => { goBackNewTest(); dispatch(saveSelectQuestion([])); }} alt='' />&nbsp;Add Questions</h3>
                                    <p className='manullheadpara' >VIEW SELECTION ({selectedQuestion?.length})</p>
                                    <button className='manuallbtn' onClick={manuallsummary} >Done</button>
                                </div>
                                <div className='manuallsearch search-tests mt-3'>
                                    <div className="has-search">
                                        <span className="form-control-feedback">
                                            <img src="/images/search.svg" alt='' width={12} />
                                        </span>
                                        <input type="search" className="form-control" placeholder='Search for test' value={query} onChange={(e) => changeSearch(e.target.value)} />
                                    </div>
                                    <div className='d-flex align-items-center' style={{ gap: 5 }} >
                                        <div className='summaryfiels-dropdowns' style={{ width: 165 }}>
                                            <Select
                                                components={{ DropdownIndicator }}
                                                placeholder='Knowledge Area'
                                                options={skills}
                                                value={area}
                                                onChange={(e) => selectSkill(e)}
                                                isClearable
                                                isDisabled={false}
                                            />
                                        </div>
                                        <div className='summaryfiels-dropdowns' style={{ width: 165 }} >
                                            <Select
                                                components={{ DropdownIndicator }}
                                                placeholder='Topics / Tags'
                                                options={topics}
                                                value={topic}
                                                onChange={(e) => selectTopic(e)}
                                                isClearable
                                                isDisabled={!area?.value}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Card>
                            <div
                                dataLength={additionalQuestions && additionalQuestions?.length}
                                next={total > additionalQuestions?.length ? fetchData : ''}
                                hasMore={true}
                            >
                                <div>
                                    {isQuestionLoading ? (
                                        <div className="loading-overlay d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                            <div className="spinner-border" role="status">
                                                <span className="visually-hidden">Loading question...</span>
                                            </div>
                                        </div>
                                    ) : additionalQuestions?.length > 0 ? (
                                        additionalQuestions.map((el) => (
                                            <Card className='mannual-question-list'>
                                                <div className='ques-item'>
                                                    <div className='ques-title'>
                                                        <input type='checkbox' className='checkbox' value={el.questionID || el.id} checked={el.isChecked} onChange={(e) => selectQuestion(e, el)} />&nbsp;&nbsp;&nbsp;
                                                        <div>
                                                            <p className='manuallquestion' >{el.skillName || el.functionName}</p>
                                                            <p className='elipsis-2' dangerouslySetInnerHTML={{ __html: el?.question || el.name }} />
                                                        </div>
                                                    </div>
                                                    <div className='d-flex align-items-center'>
                                                        {el.questionTypeName === 'Multiple Choice' ?
                                                            <img src='/images/mcq.svg' alt='' width={16} height={16} /> :
                                                            <img src='/images/essay.svg' alt='' width={16} height={16} />
                                                        }&nbsp;&nbsp;
                                                        {el.questionTypeName}
                                                    </div>
                                                    <img className='manuallinfo' src='/images/info.svg' alt='' />
                                                </div>
                                            </Card>
                                        ))
                                    ) : (
                                        <div className='empty-question' style={{ background: '#FFFFFF', padding: '15px', marginTop: '5px', borderRadius: '4px', border: '1px solid rgba(0,0,0,.125)' }}>
                                            <img src='/images/magnifier.svg' alt='' />
                                            <div className='mt-2'>
                                                <h3 style={{ color: '#111928', fontWeight: '500' }}>No questions. Change the language, knowledge area, and topic to get questions.</h3>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {additionalQuestions?.length > 0 && (
                                <>
                                    {!customLoader && totalPages > 1 && (
                                        <div className="pagination mt-3">
                                            <div className="pagination-info">
                                                {totalQuestions > 0 ? (
                                                    <span>
                                                        Showing <strong>{startItem}</strong>–
                                                        <strong>{endItem}</strong> of{" "}
                                                        <strong>{totalQuestions}</strong>
                                                    </span>
                                                ) : (
                                                    <span>Showing 0–0 of 0</span>
                                                )}
                                            </div>

                                            <div className="pagination-buttons">
                                                <button
                                                    onClick={() => onManualPaginate(manualPage - 1)}
                                                    disabled={manualPage === 1}
                                                >
                                                    <img src="/images/leftarrow-icon.svg" alt="" />
                                                </button>

                                                {getPageNumbers().map((page, index) => (
                                                    <button
                                                        key={index}
                                                        disabled={page === "..."}
                                                        className={manualPage === page ? "active" : ""}
                                                        onClick={() => page !== "..." && onManualPaginate(page)}
                                                    >
                                                        {page}
                                                    </button>
                                                ))}

                                                <button
                                                    onClick={() => onManualPaginate(manualPage + 1)}
                                                    disabled={manualPage === totalPages}
                                                >
                                                    <img
                                                        src="/images/leftarrow-icon.svg"
                                                        alt=""
                                                        style={{ rotate: "180deg" }}
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                            <button className='manuallbtn mt-2' onClick={manuallsummary} >Done</button>
                        </div>
                    )}
        </Fragment>

    )
}

export default SelectQuestions;
